import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Fab,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

import "react-datepicker/dist/react-datepicker.css";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
// import { getCounterSalesStatement } from "./outstandingApi";
import { useEffect } from "react";

// import DisplayOutStandingReport from "./displayOutStandingReport";
// import OutStandingReportCart from "./outStandingReportCart";

import {
  convertDateToCustomFormat,
  downloadXLSXFile,
} from "../../utils/commonUtils";
import { api } from "../../utils/api";
// import { getCounterSales } from "./outStandingReportCustomApiHandler";
// import { displayOutstading } from "./outstandingReportFunction";
import PaymentReceiptSearchModal from "../paymentReceipt/paymentReceiptSearchModal";
import {
  getEmpearningSalary,
  getUnpaidUser,
  viewPaymentSlip,
} from "../paymentReceipt/paymentReceiptApi";
import PaymentReceipt from "../paymentReceipt/paymentReceipt";
// import EmployeePayRollModal from "./employeeModal";
// import { EmployeeSalarySlipModal } from "./employeeSalarySlipModal";
// import PayrolSearchModal from "./payrollSearchModal";
import AdvancePayment from "../advancePayment/advancePayment";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { useSelector } from "react-redux";
// import Salary from "./salary";
// import OutStandingSalaryReportCard from "./outStandingReportSalarycopy";
// import { EmployeeViewReceipt } from "./employeeViewReceipt";
import { getCounterSalesStatement } from "../employeePayRoll/outstandingApi";
import { getCounterSales } from "../employeePayRoll/outStandingReportCustomApiHandler";
import EmployeePayRollModal from "../employeePayRoll/employeeModal";
const RechargeReport = () => {
  const [modalData, setModalData] = useState();
  const [outStandingBills, setOutStandingBills] = useState({
    records: [],
    totalOustandingAmount: "",
    totalRecords: "",
  });

  const [empSalary, setEmpSalary] = useState({
    records: [],
    totalOustandingAmount: "",
    totalRecords: "",
  });

  const [value, setValue] = React.useState("outstanding");

  const tabfn = (event, newValue) => {
    // setPageNo(1);

    setValue(newValue);
  };
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab
  );

  const [open, setOpen] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [openSalarySlip, setOpenSalarySlip] = useState(false);
  //-----
  const [searchOutStandingsModal, setSearchOutStandingsModal] = useState(false);

  const [upPaidBillData, setUnPaidBillData] = useState();
  const [unPaidBill, setUnPaidBill] = useState([]);
  const data = {
    customerMobile: "",
    amount: 0,
    name: "",
  };
  const [billData, setBillData] = useState(data);
  const [billFilter, setBillFilter] = useState(null);
  const [USerObject, setUSerObject] = useState(null);

  const getUnpaid = async (param) => {
    await getUnpaidUser(param)
      .then((res) => {
        console.log("unPaid user", res?.data?.data[0]);

        setUnPaidBillData(res?.data?.data[0]);
      })
      .catch((err) => {});
  };

  const getEmpSalary = async () => {};

  //----
  const filters = [
    { name: "Amount Greater than ", value: "amountgreatethan" },
    { name: "Amount Less than ", value: "amountlessthan" },
    { name: "Amount elapsed than ", value: "dayselapsed" },
    { name: "Partially Paid ", value: "partlypaid" },
  ];

  ///---pagination functions
  const [pagination, setPagination] = useState({
    page: 1,
    total: 1,
    records: 0,
    pageSize: 24,
  });
  const [payloadGetCounterSales, setPayloadGetCounterSales] = useState({
    page: 1,
    pageSize: pagination.pageSize,
    sortBy: "",
    order: 0,
    buyerGroupId: 0,
    filter: "",
    search: "",
  });
  const [numberOfRecords, setNumberOfRecords] = useState(1);
  const handleChange = (event, value) => {
    getCounterSales(
      {
        ...payloadGetCounterSales,
        page: value,
        pageSize: pagination.pageSize,
      },
      outStandingBills,
      getCounterSalesStatement,
      setNumberOfRecords,
      setOutStandingBills
    );
    setPagination({
      ...pagination,
      page: value,
    });
  };

  const [search, setSearch] = useState("");

  const [collection, setCollection] = useState([]);
  const getDataEmpEarnPercent = async (param) => {
    await viewPaymentSlip(param)
      .then((res) => {
        console.log(
          "data======= ",
          res?.data?.data?.counterSalesHeader,
          " ",
          res?.data?.data
        );

        setCollection(res?.data?.data?.counterSalesHeader);
      })
      .catch((err) => {
        console.log("error =r ", err);
      });
  };
  const getDataEmpEarnSalary = async (param) => {
    await getEmpearningSalary(param)
      .then((res) => {
        console.log(
          "data======= ",
          res?.data?.data?.counterSalesHeader,
          " ",
          res?.data?.data
        );

        setCollection(res?.data?.data?.counterSalesHeader);
      })
      .catch((err) => {
        console.log("error =r ", err);
      });
  };
  // const [value, setValue] = useState("");
  useEffect(() => {
    console.log("search ", search);
    // getCounterSales(
    //   {
    //     employeeMasterId: USerObject?.employeeMasterId,
    //     page: pagination.page,
    //     pageSize: pagination.pageSize,
    //   },
    //   outStandingBills,
    //   getCounterSalesStatement,
    //   setNumberOfRecords,
    //   setOutStandingBills
    // );

    if (businessChooseTab?.value == "settledandpaidAmount") {
      getDataEmpEarnPercent({
        employeeMasterId: USerObject?.id,
        page: 1,
        pageSize: 1000,
      });
    } else {
      getDataEmpEarnSalary({
        employeeMasterId: USerObject?.id,
        page: 1,
        pageSize: 1000,
      });
    }
  }, [USerObject, businessChooseTab]);

  useEffect(() => {
    setSearch("");
    setUSerObject(null);
    console.log("Business Choose Tab : ", businessChooseTab?.value);
  }, [businessChooseTab?.value]);

  return (
    <>
      <Box
        px={4}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            background:
              "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
            padding: "10px",
            mt: "10px",
            borderRadius: "5px",
            color: "#01008B",
            textAlign: "left",
            marginBottom: "20px",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          <Typography variant="h6">Recharge Validity Report</Typography>
        </Grid>

        {/* <Grid item xs={12}>
                  <Divider
                    sx={{
                      background: (theme) => theme.palette.primary.main,
                    }}
                  />
                </Grid>
                <Divider
                  sx={{
                    background: (theme) => theme.palette.primary.main,
                  }}
                /> */}

        <Box
          sx={{
            backgroundColor: "white",
            p: "10px",
            mt: 2,
            borderRadius: "12px",
            overflow: "auto",
            height: "75vh",
          }}
        >
          <Box
            sx={{
              minWidth: "1050px",
              width: "max-content",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                borderBottom: "1.5px solid black",
                paddingTop: "10px",
                padding: "10px",
              }}
            >
              <Box
                sx={{
                  width: "140px",
                  p: "0px 22px",
                  color: "#01008B",
                  fontWeight: 500,
                  fontSize: "15px",
                  // marginLeft: "30px",
                  textAlign: "center",
                }}
              >
                Biller Id
              </Box>
              <Box
                sx={{
                  width: "200px",
                  color: "#01008B",
                  fontWeight: 500,
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Enterprise Name
              </Box>
              <Box
                sx={{
                  width: "250px",
                  color: "#01008B",
                  fontWeight: 500,
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Mobile No.
              </Box>
              <Box
                sx={{
                  width: "200px",
                  color: "#01008B",
                  fontWeight: 500,
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Last Recharge Date
              </Box>
              <Box
                sx={{
                  width: "200px",
                  color: "#01008B",
                  fontWeight: 500,
                  fontSize: "15px",
                  textAlign: "center",
                  marginLeft: "20px",
                }}
              >
                Validity Date
              </Box>
              <Box
                sx={{
                  width: "200px",
                  color: "#01008B",
                  fontWeight: 500,
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                First Login Date
              </Box>
              <Box
                sx={{
                  width: "200px",
                  color: "#01008B",
                  fontWeight: 500,
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Last Login Date
              </Box>
            </Box>

            {/* Data rows */}
            {collection
              ?.filter((item) => item?.salaryorPercentage !== false)
              .map((item, i) => {
                return (
                  <Box
                    key={"payamentRecpt" + i}
                    sx={{
                      display: "flex",
                      p: "8px 0",
                      borderBottom: "1px solid #ccc",
                      alignItems: "center",
                      backgroundColor: "#E8E8FF",
                      width: "max-content",
                      mb: 1,
                      mt: 1,
                      borderRadius: "8px",
                      cursor: "pointer",
                    }}
                  >
                    <Box
                      sx={{
                        width: "140px",
                        p: "0px 22px",
                        fontSize: "14px",
                        // marginLeft: "30px",
                        fontWeight: "medium",
                        textAlign: "center",
                      }}
                    >
                      {item?.emaployeeName || "-"}
                    </Box>
                    <Box
                      sx={{
                        width: "200px",
                        fontSize: "14px",
                        textAlign: "center",
                        fontWeight: "medium",
                      }}
                    >
                      {convertDateToCustomFormat(
                        item?.createdDate?.split("T")[0]
                      )}
                    </Box>
                    <Box
                      sx={{
                        width: "250px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Typography fontSize="14px" fontWeight="medium">
                          {convertDateToCustomFormat(
                            item?.fromDate?.split("T")[0]
                          )}
                        </Typography>
                        <Typography fontSize="14px" fontWeight="medium">
                          To
                        </Typography>
                        <Typography fontSize="14px" fontWeight="medium">
                          {convertDateToCustomFormat(
                            item?.toDate?.split("T")[0]
                          )}
                        </Typography>
                      </Stack>
                    </Box>
                    <Box
                      sx={{
                        width: "200px",
                        fontSize: "14px",
                        textAlign: "center",
                        fontWeight: "medium",
                      }}
                    >
                      {item?.paymentMethod || "-"}
                    </Box>
                    <Box
                      sx={{
                        width: "200px",
                        fontSize: "14px",
                        textAlign: "center",
                        fontWeight: "medium",
                        marginLeft: "20px",
                      }}
                    >
                      {item?.transactionDetails || "-"}
                    </Box>

                    <Box
                      sx={{
                        width: "200px",
                        fontSize: "14px",
                        fontWeight: "medium",
                        textAlign: "center",
                      }}
                    >
                      ₹ {item?.amount?.toFixed(2) || "0.00"}
                    </Box>
                    <Box
                      sx={{
                        width: "200px",
                        fontSize: "14px",
                        fontWeight: "medium",
                        textAlign: "center",
                      }}
                    >
                      ₹ {item?.amount?.toFixed(2) || "0.00"}
                    </Box>
                  </Box>
                );
              })}
          </Box>
        </Box>

        <EmployeePayRollModal
          modalData={modalData}
          setModalData={setModalData}
          open={open}
          setOpen={setOpen}
        />
      </Box>
      {/* <Grid
                  container
                  sx={{
                    marginX: "20px",
                  }}
                >
                  {collection?.map((item, i) => {
                    console.log("Outstanding item ", item); */}
      {/* if (
                       !item?.buyerName?.toLowerCase().includes(search.toLowerCase()) &&
                       !item?.buyerMobile
                         ?.toLowerCase()
                         .includes(search.toLowerCase()) &&
                       search.length > 0
                     ) {
                       return null;
                     } */}
      {/* if (item?.salaryorPercentage === false) {
                      return null;
                    }
                    return (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        lg={4}
                        key={"payamentRecpt" + i}
                        sx={{ p: "5px", borderRight: "3px solid #dfdfdf" }}
                      >
                        <OutStandingSalaryReportCard
                          item={item}
                          setOpen={setOpen}
                          setModalData={setModalData}
                          setOpenView={setOpenSalarySlip}
                        />
                      </Grid> */}
      {/* );
                  })}
                </Grid> */}
      {/* <DisplayOutStandingReport
              modalData={modalData}
              open={open}
              setOpen={setOpen}
              getRecept={() => {
                // getPaymentRec({ ...getPaymentObj });
              }}
            /> */}
      {/* -------- */}
      {/* <Grid container sx={{ pt: "10px" }}>
                  <Grid item xs={4}></Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{ */}
      {/* display: "flex",
                      justifyContent: "center",
                    }}
                  > */}
      {/* <Pagination
                      count={
                        Number.isInteger(numberOfRecords / pagination.pageSize)
                          ? numberOfRecords / pagination.pageSize
                          : parseInt(numberOfRecords / pagination.pageSize) + 1
                      }
                      page={pagination.page}
                      onChange={handleChange}
                    />
                  </Grid> */}
      {/* <Grid item xs={4}></Grid>
                </Grid> */}
    </>
  );
};
export default RechargeReport;